import { Toaster } from 'react-hot-toast';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import './App.css';
import AuthGuard from './components/AuthGuard';
import GuestGuard from './components/GuestGuard';
import SiteLayout from './layouts/SiteLayout';
import StationLayout from './layouts/StationLayout';
import Loading from './pages/Loading/Loading';
import ChooseSite from './pages/ChooseSite/ChooseSite';
import SiteCreate from './pages/SiteCreate/SiteCreate';
import SiteOverview from './pages/SiteOverview/SiteOverview';
import SiteSettings from './pages/SiteSettings/SiteSettings';
import Team from './pages/Team/Team';
import StationOverview from './pages/StationOverview/StationOverview';
import StationMonitoring from './pages/StationOverview/StationMonitoring';
import StationSettings from './pages/StationSettings/StationSettings';
import StationOperations from './pages/StationOperations/StationOperations';
import StationRentals from './pages/StationRentals/StationRentals';
import DashboardEquipments from './pages/Dashboard/pages/DashboardEquipments/DashboardEquipments';
import StationCreate from './pages/StationCreate/StationCreate';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Invitation from './pages/Invitation/Invitation';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AuthGuard />}>
          <Route path="/loading" element={<Loading />} />
          <Route path="/sites" element={<ChooseSite />} />
          <Route path="/sites/new" element={<SiteCreate />} />
          <Route path="/site/:siteId" element={<SiteLayout />}>
            <Route index element={<SiteOverview />} />
            <Route path="settings" element={<SiteSettings />} />
            <Route path="team" element={<Team />} />
            <Route path="station/new" element={<StationCreate />} />
            <Route path="station/:stationId" element={<StationLayout />}>
              <Route index element={<StationOverview />} />
              <Route path="operations" element={<StationOperations />} />
              <Route path="monitoring" element={<StationMonitoring />} />
              {/* Legacy path → keep old bookmarks working */}
              <Route path="sync-history" element={<Navigate to="../monitoring" replace />} />
              <Route path="settings" element={<StationSettings />} />
              <Route path="rentals" element={<StationRentals />} />
              <Route path="equipments" element={<DashboardEquipments />} />
            </Route>
          </Route>
        </Route>
        <Route element={<GuestGuard />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        {/* Public: the emailed invitation token is the credential. */}
        <Route path="/invitation" element={<Invitation />} />
        <Route path="/logout" element={<Logout />} />
        {/* Redirects for backward compat */}
        <Route path="/stations" element={<Navigate to="/sites" replace />} />
        <Route path="/location/:id" element={<Navigate to="/sites" replace />} />
        <Route path="/" element={<Navigate to="/sites" replace />} />
        <Route path="*" element={<Navigate to="/sites" replace />} />
      </Routes>
      <Toaster
        toastOptions={{
          success: {
            style: {
              background: 'green',
              color: 'white',
            },
          },
          error: {
            style: {
              background: 'red',
              color: 'white',
            },
          },
        }}
      />
    </BrowserRouter>
  );
};

export default App;
